// These coworlds stay off public discovery until renamed; direct game addresses remain available.
const browseHidden = /^pudge[-_ ]?wars(?:$|[-_ ])/i;

type ListedLeague = {
  game: {
    name?: string | null;
    coworld_name?: string | null;
    game_address?: { slug?: string | null } | null;
  };
};

function isBrowseHidden(league: ListedLeague): boolean {
  return [
    league.game.coworld_name,
    league.game.name,
    league.game.game_address?.slug,
  ].some((key) => key != null && browseHidden.test(key.trim()));
}

export function listedPublic<T extends ListedLeague>(
  leagues: readonly T[],
): T[] {
  return leagues.filter((league) => !isBrowseHidden(league));
}
